import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from '../Flex';
import { Link } from '../Link';
import { Text } from '../Text';
var propTypes = {
    className: PropTypes.string,
    isLastChild: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.string,
    onClick: PropTypes.func,
};
var BreadcrumbLink = React.forwardRef(function (_a, ref) {
    var className = _a.className, isLastChild = _a.isLastChild, href = _a.href, icon = _a.icon, label = _a.label, onClick = _a.onClick;
    var linkColor = isLastChild ? 'text.dark' : 'text.light';
    return (React.createElement(Flex, { className: className, alignItems: 'center' },
        icon,
        React.createElement(Link, { href: href, color: linkColor, onClick: onClick, ref: ref }, label),
        !isLastChild && (React.createElement(Text, { m: 2, color: 'text.light' }, "/"))));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';
BreadcrumbLink.propTypes = propTypes;
BreadcrumbLink.defaultProps = {
    className: '',
};
export default BreadcrumbLink;
//# sourceMappingURL=BreadcrumbLink.js.map